module.exports = __webpack_public_path__ + "static/media/iguazu-falls-18.3b86bfa0.jpg";